<template>
    <div class="content" :style="{
            overflow: bOptional ? 'hidden' : '',
            height: bOptional ? '100vh' : '',
        }">
        <div class="title">AI-LiNK冷暖风水专业集成项目清单明细</div>
        <div class="spread">
            <div class="header">
                <div class="header_title">展示报价</div>
                <mt-switch v-model="bSave"></mt-switch>
            </div>
            <div class="list_item" v-for="(item, index) in arrOffter" :key="index">
                <div class="list_header">
                    <div class="min_title">
                        {{
                            "Step" +
                            item.info.step +
                            ":" +
                            item.info.type_group_name
                        }}
                    </div>
                    <div class="optional" v-if="item.info.optional != 0" @click="getMatch(item, index)">
                        修改
                    </div>
                </div>
                <div class="tabel_title">
                    <div class="tabel_title_item">名称</div>
                    <div class="tabel_title_item">规格型号</div>
                    <div class="tabel_title_item">单价</div>
                    <div class="tabel_title_item">数量</div>
                </div>
                <div class="tabel_content">
                    <div :class="[
                            'tabel_content_list',
                            sumitem.eait ? 'tabel_content_edit_list' : '',
                        ]" v-for="(sumitem, sumindex) in item.goods" :key="sumindex">
                        <div class="tabel_content_item">{{ sumitem.name }}</div>
                        <div class="tabel_content_item">{{ sumitem.code }}</div>
                        <div class="tabel_content_item">
                            <div :class="[
                                    sumitem.amount == 0
                                        ? 'border_item'
                                        : sumitem.openAmount
                                        ? 'fontSize_item'
                                        : '',
                                ]">
                                <input type="number" @click="
                                        getTipsInput(
                                            index,
                                            sumindex,
                                            sumitem,
                                            1
                                        )
                                    " readonly :value="
                                        sumitem.amount == 0
                                            ? ''
                                            : sumitem.amount
                                    " />
                            </div>
                        </div>
                        <div class="tabel_content_item">
                            <input type="number" @blur="getAmount(index, sumindex, $event, 2)" :value="sumitem.num" />
                        </div>
                    </div>
                </div>
                <div class="subtotal">
                    <div>小计:</div>
                    <div>{{ item.nAmount.toFixed(2) + "元" }}</div>
                </div>
            </div>
            <div class="total">
                <div>总计:</div>
                <div>{{ nSubtotal.toFixed(2) + "元" }}</div>
            </div>
        </div>
        <div class="btn_sumbit" @click="submit">确认</div>
        <div class="mask" v-if="areaPopupShow">
            <div class="input-area-popup">
                <div class="input-area-close" @click.stop="getOut"></div>
                <div class="input-area-title">{{ itemName }}:</div>
                <div class="input-area-content">
                    <div class="input-wrap">
                        <input type="number" pattern="[0-9]*" v-model="areaPopupInputVal" />
                        <span>元</span>
                    </div>
                </div>
                <div class="input-area-btn">
                    <button @click.stop="areaPopupConfirm()">确定</button>
                </div>
            </div>
        </div>
        <!-- 选配弹窗 -->
        <optional :bOptional.sync="bOptional" :arrOffter.sync="arrOffter" @complete="complete"></optional>
        <!-- @areaOpiton="areaOpiton" -->
    </div>
</template>
<script>
import oStorage from '@/libsV2/storage.js';
import optional from "../offter/components/optional/index";
import oDetail from "@/js/detail.js";
import { Toast } from "mint-ui";
export default {
    components: {
        optional,
    },
    data() {
        return {
            bSave: true, // 是否展示
            nSubtotal: 0, ///总计
            arrOffter: [],
            arrData: [],
            areaPopupShow: false,
            areaPopupInputVal: "",
            bgIndex: 0,
            sumIndex: 0,
            itemName: "",
            bOptional: false,
            arrOptional: [], //选配产品
            typeIndex: 0,
            nInfoIndex: 0,
        };
    },
    created() {
        let that = this;
        this.$store.commit("loadSwitch", true);
        $init(() => {
            that.getWindInfo();
        });
    },
    methods: {
        //弹窗回调
        complete(e) {
            this.arrOffter[this.nInfoIndex] = e;
            let arrGoodsShopp = [];
            e.goods.forEach((it) => {
                if (it.optional_id && it.optional_id != 0) {
                    arrGoodsShopp.push(it.optional_id);
                }
            });
            if (arrGoodsShopp.length) {
                for (let j = 0; j < this.arrOffter.length; j++) {
                    for (let i = 0; i < this.arrOffter[j].goods.length; i++) {
                        //  console.log(this.arrOffter[j].goods[i])
                        for (let a = 0; a < arrGoodsShopp.length; a++) {
                            if (this.arrOffter[j].goods[i].id == arrGoodsShopp[a]) {
                                this.arrOffter[j].goods.splice(i, 1);
                                i--;
                            }
                        }
                    }
                };
                //  console.log(arrGoodsShopp);
            }
            this.numberSeat(this.arrOffter);
        },
        areaOpiton(e) {
            this.arrOffter[this.typeIndex].goods.forEach((it, index) => {
                if (it.id == e.id) {
                    this.arrOffter[this.typeIndex].goods.splice(index, 1);
                }
            });
            this.arrOffter.forEach((item, index) => {
                item.goods.forEach((it, sumindex) => {
                    if (it.id == e.id) {
                        if (this.typeIndex != index) {
                            Toast({
                                message:
                                    e.name +
                                    "与" +
                                    it.name +
                                    "存在互斥已删除" +
                                    it.name,
                                duration: 1500,
                            });
                            this.arrOffter[index].goods.splice(sumindex, 1);
                        }
                    }
                });
            });
            this.arrOffter[this.typeIndex].goods.push(e);
            this.numberSeat(this.arrOffter);
        },
        //初始化报价单
        getWindInfo() {
            let that = this;
            let nReportId = that.$store.state.nAntReportId;
            // let nReportId = 615;
            let windInfoData = {
                report_id: nReportId,
            };
            oDetail.getWindInfo(windInfoData).then((res) => {
                let arrOffter = res.result;
                that.numberSeat(arrOffter);
                this.$store.commit("loadSwitch", false);
            });
        },
        //点击单价出现弹窗
        getTipsInput(index, sumindex, item, type) {
            this.areaPopupShow = true;
            this.bgIndex = index;
            this.sumIndex = sumindex;
            this.itemName = item.name;
        },
        getOut() {
            this.areaPopupShow = false;
            this.areaPopupInputVal = "";
        },
        //单价确认
        areaPopupConfirm() {
            let numInput = this.areaPopupInputVal;
            this.arrOffter[this.bgIndex].goods[this.sumIndex].amount = numInput;
            this.arrOffter[this.bgIndex].goods[this.sumIndex].openAmount = true;
            this.numberSeat(this.arrOffter);
            this.areaPopupShow = false;
            this.areaPopupInputVal = "";
        },
        getAmount(index, sumindex, e, type) {
            if (type == 1) {
                let numInput = e.target.value;
                this.arrOffter[index].goods[sumindex].amount = numInput;
                this.numberSeat(this.arrOffter);
            } else if (type == 2) {
                let numInput = e.target.value;
                this.arrOffter[index].goods[sumindex].num = numInput;
                this.numberSeat(this.arrOffter);
            }
        },
        //选择那部分修改
        getMatch(itemGoods, index) {
            let _that = this;
            // _that.getNoWindInfo();
            _that.nInfoIndex = index;
            // localStorage.setItem(
            //     "arrOffter",
            //     JSON.stringify(this.arrOffter[index])
            // );
             oStorage.setStorage(
                "arrOffter",
                JSON.stringify(this.arrOffter[index])
            );
            _that.bOptional = true;
        },
        //计算小计和总计
        numberSeat(arrOffter) {
            let that = this;
            let nSubtotal = 0;
            let arrData = [];
            arrOffter.forEach((it) => {
                let nPrice = 0;
                let arrGoods = [];
                it.goods.forEach((item) => {
                    nPrice =
                        Number(item.amount) * Number(item.num) + Number(nPrice); //小计
                    arrGoods.push({
                        id: item.id,
                        new_goods_type_id: item.new_goods_type_id || "",
                        code: item.code,
                        amount: item.amount,
                        name: item.name,
                        num: item.num,
                        eait: false,
                        openAmount: false,
                    });
                });
                //  console.log(arrGoods);
                it.nAmount = nPrice;
                nSubtotal = Number(it.nAmount) + Number(nSubtotal); //总计
                if (it.info) {
                    arrData.push({
                        info: {
                            type_group_name: it.info.type_group_name,
                            group_type: it.info.group_type,
                        },
                        goods: arrGoods,
                    });
                }
            });
            that.nSubtotal = nSubtotal;
            that.arrData = arrData;
            that.arrOffter = arrOffter;
            //  console.log("标记", that.arrData);
        },
        submit() {
            // let arrAmount = [];
            // this.arrData.forEach((item) => {
            //     item.goods.forEach((it) => {
            //         if (Number(it.amount).toFixed(0) == 0) {
            //             arrAmount.push(it.amount);
            //         }
            //     });
            // });
            // if (arrAmount.length != 0) {
            //     Toast({
            //         message: "商品单价不能为0",
            //         duration: 1200,
            //     });
            //     return false;
            // }
            this.getSave().then(() => {
                this.$router.replace("/ant/parameter");
            });
        },
        //保存报价单
        getSave() {
            let that = this;
            let saveData = {
                report_id: that.$store.state.nAntReportId,
                data: JSON.stringify(that.arrData),
            };
            if (that.bSave) {
                saveData.show_amount = 1;
            } else {
                saveData.show_amount = 0;
            }
            this.$store.commit("loadSwitch", true);
            return new Promise((resolve) => {
                oDetail.getSave(saveData).then((res) => {
                    this.$store.commit("loadSwitch", false);
                    Toast({
                        message: "保存成功~",
                        duration: 1200,
                    });
                    resolve();
                });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>
